import firebase from 'firebase/app';
//import "firebase/auth";
import 'firebase/firestore';
import 'firebase/functions';
//import "firebase/storage";
//import "firebase/messaging";
//import "firebase/database";

const firebaseConfig = {
  apiKey: 'AIzaSyA6thmYs-gvkOegdDqccf2cdvT5nGC0iLw',
  authDomain: 'neumaticos-las-delicias.firebaseapp.com',
  databaseURL: 'https://neumaticos-las-delicias.firebaseio.com',
  projectId: 'neumaticos-las-delicias',
  storageBucket: 'neumaticos-las-delicias.appspot.com',
  //messagingSenderId: "504916507340",
  appId: '1:504916507340:web:8044dc477f9607ba056069',
  measurementId: 'G-SZGQ4FQLNM',
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();
// firebase.functions().useFunctionsEmulator("http://localhost:5000"); //

const functions = firebase.functions();
export default firebase;
export { functions, firebase };
